import type { RuleAliases } from '@vuetify/v0'
import type { Composer } from 'vue-i18n'
import {
  allowedRule,
  capitalRule,
  ccCSCRule,
  ccMonthRule,
  ccNumberRule,
  ccYearRule,
  checkedRule,
  digitRule,
  emailRule,
  lowercaseRule,
  noSpecialCharsRule,
  positiveRule,
  requiredRule,
  symbolRule,
  type ValidationRule
} from './index'

const PARAMETERLESS = {
  required: requiredRule,
  checked: checkedRule,
  positive: positiveRule,
  email: emailRule,
  digit: digitRule,
  capital: capitalRule,
  lowercase: lowercaseRule,
  allowed: allowedRule,
  noSpecialChars: noSpecialCharsRule,
  symbol: symbolRule,
  ccNumber: ccNumberRule,
  ccCSC: ccCSCRule,
  ccMonth: ccMonthRule,
  ccYear: ccYearRule
} satisfies Record<string, (message?: string) => ValidationRule>

export const ruleAliases = (t?: Composer['t']): Partial<RuleAliases> =>
  Object.fromEntries(
    Object.entries(PARAMETERLESS).map(([alias, rule]) => [
      alias,
      (value: unknown) => rule(t ? String(t(`ui.validation.${alias}`)) : undefined)(value)
    ])
  )
